import axios from "axios";
import {
    GET_STUDENT_REQUEST,
GET_STUDENT_SUCCESS,
GET_STUDENT_FAIL,
UPLOAD_FILE_REQUEST,
UPLOAD_FILE_SUCCESS,
UPLOAD_FILE_FAIL,
CLEAR_ERROR,
GET_FILE_REQUEST,
GET_FILE_SUCCESS,
GET_FILE_FAIL,
STUDENT_UPDATE_REQUEST,
STUDENT_UPDATE_SUCCESS,
STUDENT_UPDATE_FAIL,
GET_STUDENT_DETAIL_REQUEST,
GET_STUDENT_DETAIL_SUCCESS,
GET_STUDENT_DETAIL_FAIL,
STUDENT_ASIGN_REQUEST,
STUDENT_ASIGN_SUCCESS,
STUDENT_ASIGN_FAIL,
GET_ASIGN_APPLICATION_REQUEST,
GET_ASIGN_APPLICATION_SUCCESS,
GET_ASIGN_APPLICATION_FAIL,
GET_DASHBOARD_REQUEST,
GET_DASHBOARD_SUCCESS,
GET_DASHBOARD_FAIL
} from '../constants/fileConstant'
import host from "../utils/var";



export const fileUpload = (fileData) => async (dispatch) => {
    try {
        
        dispatch({ type: UPLOAD_FILE_REQUEST });
        // console.log('ok file 1')
        const config = { headers: { "Content-Type": "application/json" }, withCredentials:true };

      const data = await axios.post(`${host}/api/v1/file/upload`, fileData , config);
      // console.log('ok file 2')

      dispatch({ type: UPLOAD_FILE_SUCCESS, payload: data.data.user });
      // console.log(data.user)
    } catch (error) {
      // console.log('ok file 3')

      dispatch({
        type: UPLOAD_FILE_FAIL,
        payload:error.response.data.message,
      });
    }
  };

  export const getStudentsData = (keyword,userId,page) => async (dispatch) => {
    try {
      dispatch({ type: GET_STUDENT_REQUEST });
      const config = { headers: { "Content-Type": "application/json" }, withCredentials:true };
      // console.log("ok student")

      const data = await axios.get(`${host}/api/v1/students/${userId}?keyword=${keyword}&page=${page}`, config);

      dispatch({ type: GET_STUDENT_SUCCESS, payload: data.data });
      // console.log(data.user)
    } catch (error) {
      dispatch({
        type: GET_STUDENT_FAIL,
        payload:error.response.data.message,
      });
    }
  };

  // get Student details
  export const getStudent = (id) => async (dispatch) => {
    // console.log("ppp")
    try {
      dispatch({ type: GET_STUDENT_DETAIL_REQUEST });
      const config = { withCredentials:true };
      // console.log("ok student")

      const data = await axios.get(`${host}/api/v1/get/student/${id}`, config);

      dispatch({ type: GET_STUDENT_DETAIL_SUCCESS, payload: data.data.student }); 
      // console.log(data.user)
    } catch (error) {
      dispatch({
        type: GET_STUDENT_DETAIL_FAIL,
        payload:error.response.data.message,
      });
    }
  };


  export const getFlesData = () => async (dispatch) => {
    try {
      dispatch({ type: GET_FILE_REQUEST });
      const config = { headers: { "Content-Type": "application/json" }, withCredentials:true };
      // console.log("ok student")

      const data = await axios.get(`${host}/api/v1/files`, config);

      dispatch({ type: GET_FILE_SUCCESS, payload: data.data.files });
      // console.log(data.user)
    } catch (error) {
      dispatch({
        type: GET_FILE_FAIL,
        payload:error.response.data.message,
      });
    }
  };

  export const getDashboard = () => async (dispatch) => {
    try {
      dispatch({ type: GET_DASHBOARD_REQUEST });
      const config = { headers: { "Content-Type": "application/json" }, withCredentials:true };
      // console.log("ok student")

      const data = await axios.get(`${host}/api/v1/dashboard`, config);

      dispatch({ type: GET_DASHBOARD_SUCCESS, payload: data.data });
      // console.log(data.user)
    } catch (error) {
      dispatch({
        type: GET_DASHBOARD_FAIL,
        payload:error.response.data.message,
      });
    }
  };

  export const studentdUpdate = (id,fileData,documentsFiles) => async (dispatch) => {
      const bodyData = {fileData, documentsFiles}
    try {
        
        dispatch({ type: STUDENT_UPDATE_REQUEST });
        // console.log('ok file 1')
      const config = { headers: { "Content-Type": "application/json" }, withCredentials:true };

      const data = await axios.put(`${host}/api/v1/student/update/${id}`, bodyData , config);
      // console.log('ok file 2')

      dispatch({ type: STUDENT_UPDATE_SUCCESS, payload: data.data.student });
      // console.log(data.user)
    } catch (error) {
      // console.log('ok file 3')

      dispatch({
        type: STUDENT_UPDATE_FAIL,
        payload:error.response.data.message,
      });
    }
  };
  export const studentdAsign = (userId,studentId) => async (dispatch) => {
    try {
        
        dispatch({ type: STUDENT_ASIGN_REQUEST });
        // console.log('ok file 55')
      const config = { headers: { "Content-Type": "application/json" }, withCredentials:true };

      const data = await axios.put(`${host}/api/v1/student/asign/${studentId}`, {userId} , config);
      // console.log('ok file 2')

      dispatch({ type: STUDENT_ASIGN_SUCCESS, payload: data?.data.message });
      // console.log(data.user)
    } catch (error) {
      console.log('ok file 3')

      dispatch({
        type:STUDENT_ASIGN_FAIL,
        payload:"server error",
      });
    }
  };
  export const getAsignedApplications = (userId, searchWord,page) => async (dispatch) => {
    try {
      dispatch({ type: GET_ASIGN_APPLICATION_REQUEST });
      const config = { withCredentials:true };
      // console.log("ok student")

      const data = await axios.get(`${host}/api/v1/asign/applications/${userId}?keyword=${searchWord}&page=${page}`, config);

      dispatch({ type: GET_ASIGN_APPLICATION_SUCCESS, payload: data.data});
      // console.log(data.user)
    } catch (error) {
      dispatch({
        type: GET_ASIGN_APPLICATION_FAIL,
        payload:error.response.data.message,
      });
    }
  };
  export const clearError = () => async (dispatch) => {
    dispatch({ type: CLEAR_ERROR });
  };

